"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PasscodeV2_1 = require("./PasscodeV2");
exports.default = PasscodeV2_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/Passcode/index.js
// module id = 1723
// module chunks = 8